module.exports = __webpack_public_path__ + "img/receipt-item-blue.f1800872.svg";